import React from "react"

import VScroll from "../../../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import {
    DashboardTemplateConfig,
    dashboardTemplatesCustom,
    emptyCustomDashboardTemplate
} from "../../../../../../core/gd-modules/dashboard/templates/templates-custom"
import DashboardTemplatePreview from "../template-preview/dashboard-template"
import {createCustomDashboard} from "../../actions/create-custom-dashboard"
import {BreadcrumbElement} from "../../../../../../core/gd-components/breadcrumbs/breadcrumbs-custom"
import {QuickAddBreadcrumbElement} from "../../../../@types"
import QuickAdd_BreadcrumbNavigation from "../../../../layout/page-title/form-title-breadcrumb"
import Template from "../../../../../../core/model2/template/template";
import NewDashboardMain from "../../new-dasshboard-main";
import QuickAdd_Group from "../../../../common/group";
import {createCustomDashboardFromTemplate} from "../../actions/create-custom-dashboard-from-template";

type Props = {
    className?  : string,
    app         : NewDashboardMain
    initParams  : any
}

export default function QuickAdd_NewDashboard_SelectCustomDashboardTemplate(props: Props) {

    const myTemplates          : Template[]     = gd.session.templates.customDashboards
    const shouldShowMyTemplates: boolean        = myTemplates?.length > 0

    const gdTemplates = _.filter(dashboardTemplatesCustom, (template: DashboardTemplateConfig) => {
        return template.templateId !== 'empty'
    })

    const onSelectGdTemplate = (template:DashboardTemplateConfig) => {
        if (!template.configComponent) {
            createCustomDashboard(template, props.initParams)
        } else {
            props.app.setState({
                gdTemplate : template
            })
        }
    }

    const onSelectMyTemplate = (template:Template) => {
        createCustomDashboardFromTemplate(template, props.initParams)
    }

    const breadcrumbItems: BreadcrumbElement[] = [
        QuickAddBreadcrumbElement.DASHBOARD,
        QuickAddBreadcrumbElement.CUSTOM_DASHBOARD
    ]

    return (
        <div className="new-main dashboard">

            <QuickAdd_BreadcrumbNavigation breadcrumbItems={breadcrumbItems}/>

            <VScroll className="quick-add-content p-t-25">

                <QuickAdd_Group className="m-b-20">
                    <DashboardTemplatePreview
                        template    = {emptyCustomDashboardTemplate}
                        onClick     = {onSelectGdTemplate}
                        imgClassName= "w-35 h-35"

                    />
                </QuickAdd_Group>


                {shouldShowMyTemplates &&
                    <QuickAdd_Group title="My Templates" className="m-b-20">
                        <div className="flex-column-left-top w-100p m-t-10">
                            {_.map(myTemplates, (myTemplate,key) => (
                                <DashboardTemplatePreview
                                    key         = {key}
                                    template    = {myTemplate}
                                    onClick     = {onSelectMyTemplate}
                                    imgClassName= "w-90 h-60 thumbnail"
                                />
                            ))}
                        </div>
                    </QuickAdd_Group>
                }

                <QuickAdd_Group title="GoodDay Templates" className="m-b-20">
                    <div className="flex-column-left-top w-100p m-t-10">
                        {_.map(gdTemplates, (gdTemplate, key) => (

                            <DashboardTemplatePreview
                                key         = {key}
                                template    = {gdTemplate}
                                onClick     = {onSelectGdTemplate}
                                imgClassName= "m-l-10 m-t-6 w-175 h-80"
                            />


                        ))}
                    </div>
                </QuickAdd_Group>


            </VScroll>
        </div>
    )

}
